import { LandingHeader } from "@/components/landing/LandingHeader";
import { LandingHero } from "@/components/landing/LandingHero";
import { LandingHowItWorks } from "@/components/landing/LandingHowItWorks";
import { LandingAdvantages } from "@/components/landing/LandingAdvantages";
import { LandingPricing } from "@/components/landing/LandingPricing";
import { LandingTrustBar } from "@/components/landing/LandingTrustBar";
import { LandingFooter } from "@/components/landing/LandingFooter";

export default function LandingPage() {
  return (
    <div className="bg-[#F8FAFC] min-h-screen" data-testid="landing-page">
      <LandingHeader />
      <LandingHero />
      <LandingHowItWorks />
      <LandingAdvantages />
      <LandingPricing />
      <div id="trust">
        <LandingTrustBar />
      </div>
      <LandingFooter />
    </div>
  );
}
